import React from "react";
import { Container } from "react-bootstrap";

import './Section.css'

function Herosection() {
    return(
        <>
           <Container className="">
                <h1 className="m-auto mt-5">
                    Our Project
                </h1>
                <hr className="w-25 m-auto mt-3 mb-5"/>
                
           </Container>
        </>
    )
}
export default Herosection